// extracted by mini-css-extract-plugin
module.exports = {"header":"portalContent_header__3wt1F","title":"portalContent_title__1n-9e"};